import React, { createContext } from "react"
import { noop } from "lodash"

import { Account } from "@/services"

export enum EPage {
    Loading = "loading", // 加载页面
    Preview = "preview", // 预热页面
    Lobby = "lobby", // 主页面
}

export interface IPageProps {
    className?: string
    style?: React.CSSProperties
    onNext?: () => void
}

export enum ESubPage {
    Relic = "relic", // 层间图形展示-箱底祭器
    PV = "pv", // 视频展示-空思白念
    Enemy = "enemy", // 敌人图鉴-仇人腥血
    Record = "record", // 数据回顾-旧乡晶尘
    Game = "game", // 预热小游戏-笞心钥索
    Collection = "collection", // 收藏品展示-无名图腾
}

export interface ISubPageProps {
    className?: string
    style?: React.CSSProperties
    visible: boolean
    onExit?: () => void
}

interface IGlobalState {
    user: Account | null // 用户信息
    hasRole: boolean
    currentPage: EPage // 当前主页面
    currentSubPage: ESubPage | null // 当前子页面
    showRegistry: boolean // 是否展示登陆窗口
    type: string // rogue类型

    show: boolean
    fontSize: number
    bgm: boolean
    assertLoaded: boolean
}

interface IAction {
    type: "updateContext" | "closeSubPage"
    payload?: Partial<IGlobalState>
}

export const initialGlobalState: IGlobalState = {
    user: null,
    hasRole: true,
    currentPage: EPage.Loading,
    currentSubPage: null,
    showRegistry: false,
    type: "rogue_4",

    show: false,
    fontSize: 16,
    bgm: true,
    assertLoaded: false,
}

export const GlobalContext: React.Context<{
    state: IGlobalState
    dispatch: React.Dispatch<IAction>
}> = createContext({
    state: initialGlobalState,
    dispatch: noop,
})

export type IReducer = React.Reducer<IGlobalState, IAction>

export const globalReducer: IReducer = (state, { type, payload }) => {
    const newState = { ...state, ...(payload || {}) }

    switch (type) {
        case "updateContext":
            return newState
        case "closeSubPage":
            return {
                ...newState,
                currentSubPage: null,
            }
        default:
            return state
    }
}
